import React, { useEffect, useState } from 'react';
import uri from '../utils/uri';
import http from '../utils/http';

import {
    CircularProgress,
    Container
} from '@mui/material';

import { ConfigContext } from './ConfigContext';
import './style.css';

export const ConfigProvider = (props) => {
    const [loading, setLoading] = useState(true);
    const [config, setConfig] = useState({});

    useEffect(() => {
        const run = async () => {
            const result = await http.get({}, `${uri.shadow}/config`, { authHeader: false });
            localStorage.setItem('uiConfig', JSON.stringify(result));

            setConfig(result);
            setLoading(false);
        };
        run();
    }, [])


    return (
        <React.Fragment>
            {loading &&
                <Container>
                    <CircularProgress />
                </Container>
            }
            {!loading &&
                <ConfigContext.Provider value={{ config, setConfig }}>
                    {props.children}
                </ConfigContext.Provider>
            }
        </React.Fragment>
    );

}
